<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-center px-2>
      <v-flex xs12 >
        <ProductDetails
          v-bind:productData="productData"
          v-bind:productPhotos="productPhotos"
        />
      </v-flex>
      <v-flex xs12 py-2 v-if="$route.params.id">
        
        <productReview
          v-bind:productId="$route.params.id"/>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ProductDetails from "./productDetails";
import productReview from "./productReview";
export default {
  props: ["id"],
  components: {
    ProductDetails,
    productReview,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      productData: {},
      productPhotos: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/view/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
        // params: {
        //   id: this.$route.params.id,
        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.productData = response.data.data;
          this.productPhotos = this.productData.photos;
          this.productData.rating=JSON.parse(this.productData.rating)
          this.loadContent = true;
            if (this.productData.isColor) {
              this.productData.colorDetails = this.productData.colorDetails.map((y) => {
                y.color = JSON.parse(y.color);
                y.colorHex = y.color.toString(16);
                y.colorHex = y.colorHex.substring(2);
                y.colorHex = "#" + y.colorHex;
                return y;
              });
            }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>